module.exports = __webpack_public_path__ + "static/media/factory.611c58c9.svg";